import { useEffect, useState } from "react";
import { observer, inject } from "mobx-react";
import styled, { useTheme } from "styled-components";
import { format } from "date-fns";
import navigateImg from "../../assets/img/outline-keyboard_arrow_left.svg";
import { useTranslation } from "react-i18next";
import Text from "../Text";
import ToggleSwitch from "../ToggleSwitch";
import { useMobile } from "../../utils/mobile";
import { ClipLoader } from "react-spinners";

const StyledBox = styled.div(
  ({ theme, noBorder, isRowClickable, isMobile }) => ({
    flexWrap: isMobile ? "wrap" : "nowrap",
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    borderBottom: !!noBorder ? `none` : `1px solid ${theme.color.gray50}`,
    width: "100%",
    cursor: isRowClickable === true ? "pointer" : "default",
    gap: 4,
  })
);

const BoxContent = styled.div(({ theme, noBorder, width, margin, isRtl }) => ({
  width: width,
  margin: margin ? margin : "13px 0",

  [`&:nth-child(even)`]: {
    // textAlign: "end",
  },
  // [`&:not(:last-child)`]: {
  //   borderLeft: !!noBorder
  //     ? `none`
  //     : isRtl
  //     ? `1px solid ${theme.color.gray50}`
  //     : `none`,
  //   borderRight: !!noBorder
  //     ? `none`
  //     : !isRtl
  //     ? `1px solid ${theme.color.gray50}`
  //     : `none`,
  // },
}));

const TabelRow = ({
  keys,
  row,
  translation,
  bold,
  noBorder,
  margin,
  toDetails = () => {},
  onRowClick = () => {},
  onToggle,
  onBedekToggle,
  onIsBedekToggle,
  onIsContSaleToggle,
  isRowClickable = false,
  currency,
  valueWidth,
}) => {
  const theme = useTheme();
  const { t, i18n } = useTranslation(translation);
  const [currentRow, setCurrentRow] = useState(row);
  const [isLoading, setIsLoading] = useState(false);
  const isMobile = useMobile();

  const showDetails = async (currentRow) => {
    setIsLoading(true);
    try {
      await toDetails(currentRow);
    } catch (error) {
      console.error("Error navigating to details:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const [onlyType, setOnlyType] = useState(
    row.ISONLYCONTSALE === "Y" || row.BEDEK !== "Y"
      ? "ISONLYCONTSALE"
      : row.ISONLYBEDEK === "Y" || row.CONTSALE !== "Y"
      ? "ISONLYBEDEK"
      : ""
  );

  useEffect(() => {
    setCurrentRow(row);
  }, [row]);

  const handleToggle = async (event, row, toggle) => {
    event.preventDefault();
    const success = await onToggle(row, toggle);
    return success;
  };

  const handleBedekToggle = async (event, row, toggle) => {
    event.preventDefault();
    onBedekToggle(row, toggle);
  };

  const handleIsOnlyToggle = async (event, row) => {
    const type = event.target.value;
    setOnlyType(type);

    if (type === "ISONLYBEDEK") {
      await onIsBedekToggle(row, true);
    }
    if (type === "ISONLYCONTSALE") {
      await onIsContSaleToggle(row, true);
    }
  };

  return (
    <StyledBox
      noBorder={noBorder}
      isMobile={isMobile}
      onClick={() => onRowClick(currentRow)}
      isRowClickable={isRowClickable}
    >
      {!!currentRow && (
        <>
          {keys.map((key, index) => {
            return (
              <BoxContent
                margin={margin}
                width={valueWidth || key.width}
                key={`${key}${index}`}
                noBorder={noBorder}
                isRtl={i18n.dir() === "rtl"}
              >
                {key.key.includes("ACTIVE") ? (
                  <ToggleSwitch
                    disabled={!onToggle}
                    toggled={currentRow[key.key] === "Y"}
                    onToggle={(event, toggle) =>
                      handleToggle(event, currentRow, toggle)
                    }
                  />
                ) : key.key.includes("ISONLYCONTSALE") ? (
                  <>
                    <ToggleSwitch
                      name="only"
                      value="ISONLYCONTSALE"
                      type="checkbox"
                      disabled={
                        !onIsContSaleToggle ||
                        currentRow.CONTSALE !== "Y" ||
                        currentRow.BEDEK !== "Y"
                      }
                      toggled={onlyType === "ISONLYCONTSALE"}
                      onToggle={(event, toggle) =>
                        handleIsOnlyToggle(event, currentRow)
                      }
                    />
                  </>
                ) : key.key.includes("ISONLYBEDEK") ? (
                  <>
                    <ToggleSwitch
                      name="only"
                      value="ISONLYBEDEK"
                      type="checkbox"
                      disabled={
                        !onIsBedekToggle ||
                        currentRow.CONTSALE !== "Y" ||
                        currentRow.BEDEK !== "Y"
                      }
                      toggled={onlyType === "ISONLYBEDEK"}
                      onToggle={(event, toggle) =>
                        handleIsOnlyToggle(event, currentRow)
                      }
                    />
                  </>
                ) : key.key.includes("BEDEK") ? (
                  <>
                    <ToggleSwitch
                      disabled={!onBedekToggle || currentRow.ONLY_BEDEK === "Y"}
                      toggled={currentRow[key.key] === "Y"}
                      onToggle={(event, toggle) =>
                        handleBedekToggle(event, currentRow, toggle)
                      }
                    />
                  </>
                ) : key.key.includes("TODETAILS") ? (
                  isLoading ? (
                    <div>
                      <ClipLoader color={"#000000"} size={20} />
                    </div>
                  ) : (
                    <img
                      src={navigateImg}
                      alt="navigate"
                      style={{ cursor: "pointer", marginInlineStart: 20 }}
                      onClick={() => showDetails(currentRow)}
                    />
                  )
                ) : bold ? (
                  <Text.BB
                    style={{
                      color: theme.color.navy,
                      textAlign: "start",
                      cursor: "inherit",
                    }}
                  >
                    {`${
                      currentRow[key.key] === null
                        ? "-"
                        : key.key.includes("DATE")
                        ? format(new Date(currentRow[key.key]), "dd/MM/yyyy")
                        : currentRow[key.key]?.toLocaleString() || 0
                    }  ${key.currency && currency ? currency : ``}`}
                  </Text.BB>
                ) : (
                  <Text.SM
                    style={{
                      color: theme.color.gray90,
                      textAlign: "start",
                      paddingInlineStart: 14,
                      cursor: "inherit",
                    }}
                  >
                    {`${
                      currentRow[key.key] === null
                        ? "-"
                        : key.key.includes("INDEXCURRENCYNAME")
                        ? !currentRow["INDEXCURRENCYNAME"] ||
                          currentRow["NOINDEXATION"] === "Y"
                          ? t("accounts:no_index")
                          : `${t("accounts:indexed_to")}${
                              currentRow["INDEXCURRENCYNAME"]
                            } ${
                              currentRow["NOINTEREST"] === "Y"
                                ? t("accounts:without_interst")
                                : t("accounts:with_interst")
                            }`
                        : key.key.includes("DATE")
                        ? format(new Date(currentRow[key.key]), "dd/MM/yyyy")
                        : currentRow[key.key]?.toLocaleString() || 0
                    }  ${key.currency && currency ? currency : ``}`}
                  </Text.SM>
                )}
              </BoxContent>
            );
          })}
        </>
      )}
    </StyledBox>
  );
};

export default inject("tenantsStore")(observer(TabelRow));
